/* Circle A parametric hats. Units: meters. +Y up, +Z front. */
(function(global){
'use strict';
const INCH=.0254, TAU=Math.PI*2;
const crownStyles=[
 {key:'cattleman',name:'Cattleman',height:4.75,channel:.23,width:.26,dent:.30,shoulder:.64},
 {key:'brick',name:'Brick',height:4.5,channel:.23,width:.50,end:.82,dent:.28,dentDrop:.08,channelPower:6,shoulder:.68,roof:.42},
 {key:'gus',name:'Gus',height:5.25,channel:.23,width:.25,dent:.36,slope:.39,dentZ:.12,shoulder:.62},
 {key:'open',name:'Open crown',height:null,channel:0,dent:0,shoulder:.59},
 {key:'minnick',name:'Minnick',height:5.5,channel:.09,width:.32,dent:.17,shoulder:.65},
 {key:'walker',name:'Walker',height:6,channel:0,dent:.14,shoulder:.58},
 {key:'wtp',name:'West Texas Punch',height:6,channel:0,dent:.52,shoulder:.55,dentHeight:.80,dentSpan:.25},
 {key:'chl',name:'Cool Hand Luke (CHL)',height:5.625,channel:.16,dent:.13,bowl:true,roof:.27,shoulder:.72},
 {key:'teardrop',name:'Teardrop',height:4.5,channel:.22,dent:.15,bowl:true,tear:true,roof:.25,shoulder:.74,slope:.035,dentZ:.58,dentLength:.31},
 {key:'telescope',name:'Telescope / Gambler',available:false,height:4,channel:.20,dent:0,bowl:true,telescope:true,roof:.22,shoulder:.75},
 {key:'un',name:'UN',height:5.25,channel:.11,width:.57,dent:.36,channelPower:6,shoulder:.67,roof:.39}
];
const brimStyles=[
 {key:'flat',name:'Flat',lift:0},
 {key:'relaxed',name:'Relaxed',legacy:true,lift:.52,round:true,drop:.10},
 {key:'rancher',name:'Rancher',legacy:true,lift:1.02,round:true,drop:.12},
 {key:'round',name:'Round (RD)',lift:.92,round:true,drop:.18},
 {key:'j',name:'J / George Strait',lift:.90,front:1.02,back:.99,soft:.52,drop:.10},
 {key:'chl',name:'Cool Hand Luke (CHL)',lift:.74,front:1.65,back:1.25,soft:.35,drop:.06},
 {key:'u',name:'U',lift:1.00,front:1.55,back:.72,soft:.44,drop:.07},
 {key:'show',name:'Showmanship',lift:1.12,front:.86,back:.76,soft:.20,drop:.07},
 {key:'wtp',name:'West Texas Punch',lift:1.05,front:1.14,back:.70,soft:.32,drop:.07},
 {key:'jb',name:'JB',lift:.94,front:1.20,back:1.02,soft:.34,drop:.07},
 {key:'sc',name:'SC',lift:.60,front:1.35,back:1.25,soft:.75,drop:.055}
];
const crownNames=crownStyles.map(x=>x.name),brimNames=brimStyles.map(x=>x.name);
const smooth=(a,b,x)=>{const t=Math.max(0,Math.min(1,(x-a)/(b-a)));return t*t*(3-2*t)};
function shapeIndex(value,styles,fallback=0){const n=typeof value==='number'?value:/^\d+$/.test(String(value))?Number(value):styles.findIndex(s=>s.key===value);return Number.isInteger(n)&&n>=0&&n<styles.length&&styles[n].available!==false?n:fallback}
function oval(size=7.25,ratio=1.18){
 const circumference=Math.PI*size*INCH;
 const a=circumference/(Math.PI*(3*(1+ratio)-Math.sqrt((3+ratio)*(1+3*ratio))));
 return {a,b:a*ratio};
}
function normalize(v){const l=Math.hypot(...v)||1;return v.map(x=>x/l)}
function mesh(name,positions,indices,material){
 const normals=new Float32Array(positions.length);
 for(let j=0;j<indices.length;j+=3){const a=indices[j]*3,b=indices[j+1]*3,c=indices[j+2]*3;
  const u=[0,1,2].map(i=>positions[b+i]-positions[a+i]),v=[0,1,2].map(i=>positions[c+i]-positions[a+i]);
  const n=[u[1]*v[2]-u[2]*v[1],u[2]*v[0]-u[0]*v[2],u[0]*v[1]-u[1]*v[0]];
  for(const k of [a,b,c])for(let i=0;i<3;i++)normals[k+i]+=n[i];
 }
 for(let j=0;j<normals.length;j+=3){const n=normalize(Array.from(normals.slice(j,j+3)));normals.set(n,j)}
 return {name,positions:new Float32Array(positions),normals,indices:new Uint16Array(indices),material};
}
function rings(name,points,cols,material,reverse=false){
 const indices=[],rows=points.length/(cols*3);
 for(let j=0;j<rows-1;j++)for(let i=0;i<cols;i++){
  const a=j*cols+i,b=j*cols+(i+1)%cols,c=(j+1)*cols+i,d=(j+1)*cols+(i+1)%cols;
  indices.push(...(reverse?[a,c,b,b,c,d]:[a,b,c,b,d,c]));
 }
 return mesh(name,points,indices,material);
}
function create(spec,crown=0,brim=1,headSize){
 const originalH=Number(spec.openCrownInches)*INCH,W=Number(spec.brimInches)*INCH;
 if(!(originalH>=.10&&originalH<=.20&&W>=.07&&W<=.15))throw Error('Confirmed crown and brim measurements are required.');
 if(!Number.isInteger(crown)||!crownStyles[crown]||!Number.isInteger(brim)||!brimStyles[brim])throw Error('Unknown shape');
 const style=crownStyles[crown],brimStyle=brimStyles[brim];
 const H=style.height?Math.min(originalH*.96,style.height*INCH):originalH;
 const {a,b}=oval(headSize||spec.referenceHeadSize||7.25),N=128,meshes=[];
 // Reference oval; manufacturer block profiles have not been supplied.
 const shoulder=style.shoulder||.66,cap=1-shoulder;
 function profile(r,theta,wallT=1){
  let x=Math.cos(theta),z=Math.sin(theta);
  const taper=1-.065*smooth(0,1,wallT);
  if(style.tear)x*=1+smooth(.12,1,wallT)*(-.42*z-.06);
  return [a*x*r*taper,b*z*r*(1-.045*smooth(0,1,wallT))];
 }
 const p=[];
 for(let row=0;row<=64;row++){
  const wall=Math.min(1,row/28),r=row<=28?1:Math.cos((row-28)/36*Math.PI/2);
  for(let i=0;i<N;i++){
   const theta=TAU*i/N,base=profile(Math.max(r,.00001),theta,wall);
   let x=base[0],z=base[1],y=H*(row<=28?shoulder*wall:shoulder+cap*Math.pow(Math.max(0,1-r*r),style.roof||.5));
   const xn=x/a,zn=z/b,u=y/H;
   const dent=(style.dent||0)*Math.pow(Math.abs(Math.cos(theta)),4)*Math.pow(r,2)*Math.exp(-Math.pow((u-(style.dentHeight||.82))/(style.dentSpan||.22),2)-Math.pow((zn-(style.dentZ||0))/(style.dentLength||.72),4))*smooth(.38,.65,u);
   x-=Math.sign(x)*a*dent;
   y-=H*dent*(style.dentDrop??.24);
   let groove=0;
   if(style.tear)groove=(1-smooth(.57,.85,r))-.52*Math.exp(-Math.pow(r/.37,2));
   else if(style.bowl)groove=1-smooth(style.telescope?.60:.52,style.telescope?.84:.87,r);
   else if(style.channel)groove=Math.exp(-Math.pow(Math.abs(xn/(style.width||.3)),style.channelPower||2)-Math.pow(Math.abs(zn/(style.end||.98)),10));
   y-=H*(style.channel||0)*groove*smooth(.50,.86,u);
   if(style.slope)y*=1-style.slope*(zn+.20)*smooth(.18,.76,u);
   p.push(x,y,z);
  }
 }
 let highest=0;for(let i=1;i<p.length;i+=3)highest=Math.max(highest,p[i]);
 const heightScale=H/highest;for(let i=1;i<p.length;i+=3)p[i]*=heightScale;
 meshes.push(rings('crown',p,N,0,true));
 // Radial brim strips each total W meters. Bending preserves cut width.
 const R=40,brimP=[],radials=[];
 for(let i=0;i<N;i++){
  const t=TAU*i/N,base=[a*Math.cos(t),b*Math.sin(t)],direction=normalize([Math.cos(t)/a,Math.sin(t)/b]);
  let x=base[0],y=0,z=base[1];const strip=[[x,y,z]];
  const side=Math.pow(Math.abs(Math.cos(t)),2.4),front=Math.max(0,Math.sin(t));
  for(let j=1;j<=R;j++){
   const s=(j-.5)/R;
   let angle=0;
   if(brimStyle.lift){
    if(brimStyle.round)angle=brimStyle.lift*side*Math.pow(s,brim===3?.72:1.08);
    else{const blend=(Math.sin(t)+1)/2,ratio=brimStyle.back+(brimStyle.front-brimStyle.back)*blend,hinge=a+a*(ratio-1)*.5+W*.38;angle=brimStyle.lift*smooth(hinge,hinge+a*brimStyle.soft,Math.abs(base[0]+direction[0]*W*s));}
    angle-=(brimStyle.drop||0)*Math.pow(front,brimStyle.round?2:5)*Math.pow(s,1.1);
   }
   const step=W/R;x+=direction[0]*step*Math.cos(angle);z+=direction[1]*step*Math.cos(angle);y+=step*Math.sin(angle);
   strip.push([x,y,z]);
  }
  radials.push(strip);
 }
 for(let j=0;j<=R;j++)for(let i=0;i<N;i++)brimP.push(...radials[i][j]);
 meshes.push(rings('brim',brimP,N,0));
 const bottom=brimP.map((v,i)=>i%3===1?v-.002:v);meshes.push(rings('brim underside',bottom,N,0,true));
 function tube(name,centers,radius,material){
  const pts=[],K=10;
  for(let i=0;i<N;i++){
   const t=TAU*i/N,normal=normalize([Math.cos(t)/a,Math.sin(t)/b]);
   for(let j=0;j<K;j++){const q=TAU*j/K;pts.push(centers[i][0]+radius*Math.cos(q)*normal[0],centers[i][1]+radius*Math.sin(q),centers[i][2]+radius*Math.cos(q)*normal[1])}
  }
  const ids=[];for(let i=0;i<N;i++)for(let j=0;j<K;j++){const x=i*K+j,y=i*K+(j+1)%K,z=((i+1)%N)*K+j,w=((i+1)%N)*K+(j+1)%K;ids.push(x,y,z,y,w,z)}
  return mesh(name,pts,ids,material);
 }
 meshes.push(tube('brim edge',radials.map(x=>[x[R][0],x[R][1]-.001,x[R][2]]),.001,0));
 const bandP=[];
 for(let j=0;j<=4;j++){
  const height=.003+j*.0023;
  for(let i=0;i<N;i++){const [x,z]=profile(1,TAU*i/N,height/(H*shoulder));bandP.push(x*1.012,height,z*1.012)}
 }
 meshes.push(rings('narrow reference band',bandP,N,1,true));
 for(const height of [.003,.0122]){
  const centers=Array.from({length:N},(_,i)=>{const [x,z]=profile(1,TAU*i/N,height/(H*shoulder));return [x*1.013,height,z*1.013]});
  meshes.push(tube('band piping',centers,.0005,1));
 }
 for(const m of meshes)m.part=m.name.startsWith('brim')?1:m.material===1?2:0;
 return {meshes,opening:{a,b},radials,extras:{units:'meters',productId:spec.id||null,color:spec.color||null,colorStatus:spec.colorStatus||null,openCrownInches:spec.openCrownInches,brimInches:spec.brimInches,referenceFinishedHeightInches:H/INCH,heightLimited:!!style.height&&style.height*INCH>originalH*.96,headSize:headSize||spec.referenceHeadSize||7.25,crown:crownNames[crown],crownKey:style.key,brim:brimNames[brim],brimKey:brimStyle.key,crownSource:spec.crownSource,brimSource:spec.brimSource,geometryStatus:'Parametric shaping reference. Creases, block oval, band and surface finish require shaper approval. Not a scan or fit measurement.'}};
}
function color(hex){return (hex||'#aaa49b').replace('#','').match(/../g).map(s=>parseInt(s,16)/255)}
function materials(spec){const rgb=color(spec.colorHex).map(v=>Math.max(.16,v));return [rgb,rgb.map(v=>Math.max(.10,v*.64))]}
function basis(yaw=0,pitch=0,roll=0){
 const cy=Math.cos(yaw),sy=Math.sin(yaw),cx=Math.cos(pitch),sx=Math.sin(pitch),cz=Math.cos(roll),sz=Math.sin(roll);
 return [cz*cy-sz*sx*sy,sz*cy+cz*sx*sy,-cx*sy,-sz*cx,cz*cx,sx,cz*sy+sz*sx*cy,sz*sy-cz*sx*cy,cx*cy];
}
function project(point,options,viewport){
 const r=options.rotation||basis(options.yaw||0,options.pitch||0,options.roll||0),q=[0,1,2].map(i=>r[i]*point[0]+r[i+3]*point[1]+r[i+6]*point[2]);
 const w=Math.max(.05,1-q[2]*(options.perspective||0)),cx=viewport.width/2,cy=viewport.height/2;
 return {x:cx+((options.x??cx)-cx+q[0]*options.scale)/w,y:cy+((options.y??cy)-cy-q[1]*options.scale)/w,depth:options.perspective?1.02531646-.10126582*options.perspective/w:-q[2]*2};
}
function headOccluder(opening){
 const points=[],headRings=[[.065,.0001],[.05,.48],[.03,.80],[0,.97],[-.035,.98],[-.075,.92],[-.12,.79],[-.17,.60],[-.21,.0001]];
 for(const [y,r] of headRings)for(let i=0;i<48;i++){const t=TAU*i/48;points.push(opening.a*r*Math.cos(t),y,opening.b*r*.96*Math.sin(t))}
 return rings('head occlusion estimate',points,48,0);
}
function shaderSources(){return {
 vert:`attribute vec3 p;attribute vec3 n;uniform mat3 rotation;uniform vec3 origin;uniform vec2 viewport;uniform float scale;uniform float perspective;varying vec3 normal;varying vec3 local;varying vec3 localNormal;void main(){vec3 q=rotation*p;float w=max(.05,1.-q.z*perspective);float depth=perspective>0.?1.02531646*w-.10126582*perspective:-q.z*2.;gl_Position=vec4((origin.x+q.x*scale)/viewport.x*2.-1.,1.-(origin.y-q.y*scale)/viewport.y*2.,depth,w);normal=rotation*n;localNormal=n;local=p;}`,
 frag:`#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
varying vec3 normal;varying vec3 local;varying vec3 localNormal;
uniform mat3 rotation;uniform vec3 tint;uniform vec3 keyLight;uniform float sceneLight;uniform float straw;uniform float part;uniform vec2 opening;uniform float crownHeight;uniform sampler2D feltMap;uniform float textureReady;uniform float crownStyle;
float hash(vec3 p){p=fract(p*.1031);p+=dot(p,p.yzx+33.33);return fract((p.x+p.y)*p.z);}
float noise(vec3 p){vec3 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(mix(hash(i),hash(i+vec3(1,0,0)),f.x),mix(hash(i+vec3(0,1,0)),hash(i+vec3(1,1,0)),f.x),f.y),mix(mix(hash(i+vec3(0,0,1)),hash(i+vec3(1,0,1)),f.x),mix(hash(i+vec3(0,1,1)),hash(i+vec3(1,1,1)),f.x),f.y),f.z);}
void main(){
 vec3 n=normalize(normal)*(gl_FrontFacing?1.:-1.);
 vec2 feltUV=(part>.5&&part<1.5)?local.xz*10.:vec2(atan(local.z,local.x)*.09,local.y)*10.;
 float photographic=texture2D(feltMap,feltUV).r;
 float fibers=mix(noise(local*1750.),photographic,textureReady*(1.-straw));float nap=noise(local*180.);
 vec2 fiberSlope=vec2(texture2D(feltMap,feltUV+vec2(.001,0)).r-photographic,texture2D(feltMap,feltUV+vec2(0,.001)).r-photographic);
 vec3 micro=vec3(noise(local*1900.+vec3(13,5,9)),noise(local*1900.+vec3(7,19,2)),noise(local*1900.+vec3(4,3,23)))-.5;
 n=normalize(n+rotation*(micro*.025+vec3(fiberSlope,-fiberSlope.x*.3)*textureReady*.35));
 // Broad diffuse lighting and velvet-like grazing response for dense felt.
 vec3 L=normalize(keyLight),V=vec3(0.,0.,1.);
 vec3 localL=vec3(dot(rotation[0],L),dot(rotation[1],L),dot(rotation[2],L));
 float nl=max(dot(n,L),0.),nv=max(dot(n,V),0.);
 float wrap=max((dot(n,L)+.18)/1.18,0.);
 float sky=.5+.5*n.y;
 float diffuse=.12+.18*sky+.90*wrap;
 float ao=1.;float visibility=1.;
 if(part>.5&&part<1.5){
  float radius=length(local.xz/opening);
  ao=1.-.43*(1.-smoothstep(1.,1.65,radius));
  // Sample the crown volume towards the light: soft, pose-aware brim shadow.
  float blocked=0.;
  for(int i=1;i<=6;i++){
   float h=crownHeight*.90*float(i)/6.;
   float travel=(h-local.y)/max(localL.y,.12);
   vec2 ray=local.xz+localL.xz*max(travel,0.);
   float radiusAtHeight=1.-.18*h/max(crownHeight,.01);
   float inside=1.-smoothstep(radiusAtHeight-.18,radiusAtHeight+.28,length(ray/opening));
   blocked=max(blocked,inside*step(0.,travel));
  }
  visibility=1.-.40*blocked*smoothstep(0.,.35,localL.y);
  diffuse=.12+.18*sky+.90*wrap*visibility;
 }else if(part<.5){
  ao=1.-.17*exp(-abs(local.y-.013)*180.);
 }
 // Subtle nap variation, never a coarse painted texture or glossy plastic spot.
 float grain=1.+.16*(fibers-.46)+.025*(nap-.5);
 float grazing=pow(1.-nv,3.);
 float velvet=(.010+.028*grazing)*(.25+.75*sqrt(nl))*visibility;
 float weave=sin(local.x*2100.)*sin(local.z*2100.+local.y*1800.);
 grain*=1.+straw*.07*weave;
 velvet*=mix(1.,.28,straw);
 if(part>1.5){
  float ribbon=sin(local.y*16000.);
  grain=1.+.035*ribbon+.025*(fibers-.5);
  velvet*=.32;
 }
 vec3 albedo=pow(tint,vec3(2.2));
 vec3 fiberTint=mix(vec3(.72),sqrt(max(albedo,vec3(.001))),.45);
 vec3 linear=(albedo*diffuse*ao*grain+fiberTint*velvet*ao)*sceneLight;
 // Gentle highlight shoulder retains light felt colors without hard clipping.
 linear=linear/(vec3(1.)+max(linear-vec3(.65),vec3(0.))*.35);
 vec3 srgb=pow(max(linear,vec3(0.)),vec3(1./2.2));
 gl_FragColor=vec4(clamp(srgb,0.,1.),1.);
}`};}
function renderer(canvas){
 const gl=canvas.getContext('webgl',{alpha:true,antialias:true,premultipliedAlpha:false,preserveDrawingBuffer:true});
 if(!gl)throw Error('3D graphics unavailable');
 const {vert,frag}=shaderSources();
 function shader(type,src){const s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error(gl.getShaderInfoLog(s));return s}
 const program=gl.createProgram();gl.attachShader(program,shader(gl.VERTEX_SHADER,vert));gl.attachShader(program,shader(gl.FRAGMENT_SHADER,frag));gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error(gl.getProgramInfoLog(program));
 const U={};for(const k of ['rotation','origin','viewport','scale','perspective','keyLight','sceneLight','tint','straw','part','opening','crownHeight','feltMap','textureReady','crownStyle'])U[k]=gl.getUniformLocation(program,k);
 const P=gl.getAttribLocation(program,'p'),N=gl.getAttribLocation(program,'n');let buffers=[],occluder=null,model=null,spec=null;
 let textureReady=0,disposed=false,lastDraw=null;
 const surfaceTexture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,surfaceTexture);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([118,118,118,255]));
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.REPEAT);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.REPEAT);
 const feltImage=new Image();feltImage.crossOrigin='anonymous';
 const textureLoaded=new Promise(resolve=>{
  feltImage.onload=()=>{if(disposed)return resolve(false);try{
   const tile=document.createElement('canvas');tile.width=1024;tile.height=1024;tile.getContext('2d').drawImage(feltImage,0,0,1024,1024);
   gl.bindTexture(gl.TEXTURE_2D,surfaceTexture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,tile);gl.generateMipmap(gl.TEXTURE_2D);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR_MIPMAP_LINEAR);textureReady=1;if(lastDraw)draw(lastDraw);resolve(true);
  }catch(e){resolve(false)}};
  feltImage.onerror=()=>resolve(false);
 });
 feltImage.src=global.CircleAFeltTextureURL||'https://cdn.shopify.com/s/files/1/0659/0159/2739/files/Circle_A_Felt_Surface_Texture_v1.png?v=1792435676';

 function upload(m){const out={count:m.indices.length,material:m.material,part:m.part||0};for(const [key,data,target]of[['p',m.positions,gl.ARRAY_BUFFER],['n',m.normals,gl.ARRAY_BUFFER],['i',m.indices,gl.ELEMENT_ARRAY_BUFFER]]){out[key]=gl.createBuffer();gl.bindBuffer(target,out[key]);gl.bufferData(target,data,gl.STATIC_DRAW)}return out}
 function submit(b){for(const [key,loc]of[['p',P],['n',N]]){gl.bindBuffer(gl.ARRAY_BUFFER,b[key]);gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,3,gl.FLOAT,false,0,0)}gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,b.i);gl.drawElements(gl.TRIANGLES,b.count,gl.UNSIGNED_SHORT,0)}
 function set(next,crown,brim,headSize){
  for(const b of buffers)for(const key of ['p','n','i'])gl.deleteBuffer(b[key]);
  model=create(next,crown,brim,headSize);spec=next;buffers=model.meshes.map(upload);
  if(occluder)for(const k of ['p','n','i'])gl.deleteBuffer(occluder[k]);
  occluder=upload(headOccluder(model.opening));
  return model;
 }
 function draw(options={}){
  if(!model||disposed)return;lastDraw=options;const w=canvas.width,h=canvas.height;
  gl.viewport(0,0,w,h);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.disable(gl.CULL_FACE);gl.useProgram(program);
  const rot=options.rotation||basis(options.yaw||0,options.pitch||0,options.roll||0);
  gl.uniformMatrix3fv(U.rotation,false,rot);gl.uniform3f(U.origin,options.x??w/2,options.y??h*.68,0);gl.uniform2f(U.viewport,w,h);gl.uniform1f(U.scale,options.scale||w/.48);gl.uniform1f(U.straw,spec.material==='straw'?1:0);
  gl.uniform1f(U.perspective,options.perspective||0);gl.uniform3fv(U.keyLight,options.lighting?.direction||[-.55,.85,1]);gl.uniform1f(U.sceneLight,options.lighting?.exposure??1);
  gl.uniform2f(U.opening,model.opening.a,model.opening.b);gl.uniform1f(U.crownHeight,Number(spec.openCrownInches)*INCH);gl.uniform1f(U.crownStyle,crownNames.indexOf(model.extras.crown));
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,surfaceTexture);gl.uniform1i(U.feltMap,0);gl.uniform1f(U.textureReady,textureReady);
  const palette=materials(spec);
  if(options.occlude){gl.colorMask(false,false,false,false);submit(occluder);gl.colorMask(true,true,true,true)}
  for(const b of buffers){gl.uniform1f(U.part,b.part);gl.uniform3fv(U.tint,palette[b.material]);submit(b)}
 }
 function close(){disposed=true;gl.deleteTexture(surfaceTexture);for(const b of [...buffers,...(occluder?[occluder]:[])])for(const k of ['p','n','i'])gl.deleteBuffer(b[k]);gl.deleteProgram(program);gl.getExtension('WEBGL_lose_context')?.loseContext()}
 return {set,draw,close,textureLoaded,get model(){return model}};
}
const api={create,oval,materials,basis,project,headOccluder,renderer,shaderSources,crownNames,brimNames,crownStyles,brimStyles,shapeIndex,INCH};
if(typeof module!=='undefined'&&module.exports)module.exports=api;else global.CircleAHat3D=api;
})(typeof window==='undefined'?globalThis:window);
